import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';
import type { EnFaqViewModel } from '@/wabunka-src/features/FAQ/models/enFaq';

export interface FaqToggleOpenParams {
  id: string;
  question: string;
  pageUrl: string;
}

export function useFaqTracking() {
  const trackFaqOpen = (faq: EnFaqViewModel) => {
    const trackingData = {
      id: faq.id,
      question: faq.question,
      pageUrl: window.location.href.replace(/^https?:\/\//, '').split('?')[0], // e.g. example.com/experiences
    };

    sendWabunkaGAEvent('faq_toggle_open', trackingData);
  };

  return {
    trackFaqOpen,
  };
}
